module.exports = __webpack_public_path__ + "assets/icons/ic_add_a_photo-82ef.svg";